import {
  breakpointSizes,
  getBreakpointDown,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import NotFoundBottomContent from 'src/components/NotFoundBottomContent/NotFoundBottomContent'
import NotFoundTopContent from 'src/components/NotFoundTopContent/NotFoundTopContent'
import { css } from 'styled-components'

interface NotFoundPopupContentProps {
  className?: string
}

const NotFoundPopupContent: React.FC<NotFoundPopupContentProps> = (
  props,
): React.ReactElement => {
  return (
    <div className={props.className}>
      <div
        css={css`
          display: flex;
          justify-content: center;
          background-color: ${styleConstants.colors.white};
          z-index: 1;
          padding: 60px;
          border-radius: 10px;

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            padding: 30px 75px;
          `)}
        `}
      >
        <NotFoundTopContent />
      </div>
      <div
        css={css`
          flex-grow: 2;
          display: flex;
          justify-content: center;
          background-color: ${styleConstants.colors.gray_lightest};
          border: 1px solid ${styleConstants.colors.gray_light};
          border-radius: 10px;
          padding: 60px;

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            padding: 40px;
          `)}
        `}
      >
        <NotFoundBottomContent isSummary />
      </div>
    </div>
  )
}

export default NotFoundPopupContent
